module.exports = __webpack_public_path__ + "static/img/banner.8c5f6a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/banner.jpg
// module id = b0uB
// module chunks = 0